import { render } from "./SvgIcon.vue?vue&type=template&id=c962ea1e&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=c962ea1e&scoped=true&lang=css"

import exportComponent from "E:\\myFile\\2025\\qdjz\\tangh5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c962ea1e"]])

export default __exports__